import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { AssetRegisterDepreciationRunLineModel } from '../../../../../../models/aggregates/erp/asset-register';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class AssetRegisterDepreciationRunLineService extends BaseApiTemplateService<AssetRegisterDepreciationRunLineModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/depreciation-runs/lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/depreciation-runs/lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/depreciation-runs/lines/backoffice-ep';
    this.httpClient = http;
  }

}
